import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getUserTypes} from "../services/UserTypeService";
import {useLogout} from "./useLogout";

export function useUserTypes({enabled = true, managedByUserId} = {}) {
    const [userTypes, setUserTypes] = useState([]);

    const logout = useLogout();
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: ["userTypes", managedByUserId ?? null],
        queryFn: () => getUserTypes(managedByUserId),
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setUserTypes(data);
        }
    }, [data]);

    return [userTypes, refetch, isFetching];
}
